module.exports = __webpack_public_path__ + "static/media/assessments.18002956.svg";